import image1 from "../assets/image1.jpg";
import image2 from "../assets/image2.jpg";
import image3 from "../assets/image3.jpg";
import image4 from "../assets/image4.jpg";
import image5 from "../assets/image5.jpg";
import image6 from "../assets/image6.jpg";

const DataDoctors = [
  {
    id: 1,
    image: `${image1}`,
    doctor: "Dr. Jacob Martinez",
    description:
      "Dr. Jacob Martinez specializes in internal medicine with a focus on digestive disorders.",
  },
  {
    id: 2,
    image: `${image2}`,
    doctor: "Dr. Mary Brown",
    description:
      "Dr. Mary Brown is a renowned cardiologist known for her expertise in heart diseases.",
  },
  {
    id: 3,
    image: `${image3}`,
    doctor: "Dr. Laura White",
    description:
      "Dr. Laura White is an experienced pediatrician dedicated to children's health.",
  },
  {
    id: 4,
    image: `${image4}`,
    doctor: "Dr. Olivia Davis",
    description:
      "Dr. Olivia Davis specializes in orthopedic surgery and sports medicine.",
  },
  {
    id: 5,
    image: `${image5}`,
    doctor: "Dr. James Black",

    description:
      "Dr. James Black is a neurologist known for his research in neurological disorders.",
  },
  {
    id: 6,
    image: `${image6}`,
    doctor: "Dr. Alice Walker",
    description:
      "Dr. Alice Walker specializes in dermatology and skincare treatments.",
  },
];

export default DataDoctors;
